//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  name: "shiyongmendian",
  data(){
    return{
      title: 0,
      total: 0,
      content: [
        {img: "./../../static/img/gift.png", title: "四轮定位", score: 1000, gift: 0, remark: "我是详情四轮定位"},
        {img: "./../../static/img/signOut.png", title: "机油滤清", score: 200, gift: 0, remark: "我是详情机油滤清"},
        {img: "./../../static/img/user.jpg", title: "头像", score: 1, gift: 0, remark: "我是详情头像"},
        {img: "./../../static/img/store.png", title: "车身金属", score: 10000, gift: 0, remark: "我是详情车身金属"},
        {img: "./../../static/img/gift.png", title: "四轮定位", score: 1000, gift: 0, remark: "我是详情四轮定位"},
        {img: "./../../static/img/signOut.png", title: "机油滤清", score: 200, gift: 0, remark: "我是详情机油滤清"},
        {img: "./../../static/img/user.jpg", title: "头像", score: 1, gift: 0, remark: "我是详情头像"},
        {img: "./../../static/img/store.png", title: "车身金属", score: 10000, gift: 0, remark: "我是详情车身金属"}
      ],
      content1: [
        {img: "./../../static/img/user.jpg", title: "头像", score: 1, examine: "审核不通过", remark: "我是详情头像"},
      ]
    }
  },
  methods:{
    onItemClick: function(s){

    },
    math: function(){
      let num = [];
      num = this.content.map((item, index)=>{
        return item.score * item.gift;
      })
      this.total = num.reduce((item, index)=>{return item + index});
    },
    determine: function(){

    }
  },
  mounted(){

  }
}



// WEBPACK FOOTER //
// ./src/components/shiyongmendian.vue